import _ from 'lodash';
import { viTypes } from "../../cnr/reducers/CreateReducer";
import { gEnums } from "../../enums/globalEnums";
import { getTempSettingsState, ammendTempSettingsState } from '../../firestoreData/settings/ammendSettings';
import { addViewItemPropViews } from "../create/appSettingsToViews";

/** Add views, props, propSections, etc. to an object */

/**
 * 
 * @param {object} addProps (action,
    addForm,
    dataTableProps,
    formData,
    handleResponse_settingsAdded,
    initViType,
    isGlobal,
    noData,
    page_fns,
    page_state,
    paps_state,
    selectedItems,
    settings_temp,
    addModeType_state,
    state,
    swipedItem,
    vit,)
 * @returns the updated settings_temp
 */
export const settingsAdd = async (addProps) => {

  const _amts = gEnums.addModeTypes

  const {
    action,
    addForm,
    addModeType_state,
    dataTableProps,
    formData,
    gvviSettings,
    handleResponse_settingsAdded,
    initViType,
    isGlobal,
    noData,
    page_fns,
    page_state,
    pageSettings,
    paps_state,
    selectedItems,
    settings_temp,
    state,
    swipedItem,
    vit,
    fn_cls
  } = addProps

  let { settings_temp_global } = addProps
  const { createInfo } = state ?? {}
  const { settings_temp: ciSvs, views: ciViews } = createInfo ?? {}
  const { viewItems: ciViewItems } = ciSvs ?? {}
  let seletedKeys = selectedItems ? Object.keys(selectedItems) : null

  const { aps_global, aps_viewItems, aps_views } = gvviSettings ?? {}
  const { aps_page } = pageSettings ?? {}

  let _settings_temp = _.clone(settings_temp)

  let _isGlobal = isGlobal

  switch (addModeType_state) {
    case _amts.copyExisting:
      _isGlobal = true;
      break;
    default:
    // nothing
  }

  const { name: newValue } = formData
  const newValue_cc = newValue ? _.camelCase(newValue) : null

  let { _viewItems, _views } = getTempSettingsState(_settings_temp, _isGlobal)

  // IMPORTANT: Add stuff
  switch (addModeType_state) {

    case _amts.copyExisting:
      addViewAndViews(formData, _viewItems, _views)
      handleResponse_settingsAdded(_settings_temp)
      return { settings_temp: _settings_temp }

    case _amts.googleSheets:
    case _amts.googleSheetsOnly:

      if (addProps.newViews) {
        const { viewItems: vis, views: vs } = addProps.newViews
        const newViews = {}
        if (vis) { Object.keys(vis).forEach(viKey => { aps_viewItems[viKey] = vis[viKey] }) }
        if (vs) {
          Object.keys(vs).forEach(vKey => {
            aps_views[vKey] = vs[vKey]
            newViews[vKey] = vs[vKey]
          })
        }
        _viewItems = aps_viewItems
        ammendTempSettingsState(_settings_temp, true, null, _viewItems)
        // settings_temp.settings_views = aps_views
        return { settings_temp: _settings_temp, newViews }
      } else {
        let newViews = {}

        // the props within the items are already built!!!

        if (aps_global && seletedKeys && ciViewItems && ciViews) {
          seletedKeys.forEach(nvi => {
            aps_viewItems[nvi] = ciViewItems[nvi]
            newViews[nvi] = ciViews[nvi]
            newViews[nvi + '_list'] = ciViews[nvi + '_list']
          })
        }
        _viewItems = aps_viewItems
        return { settings_temp: _settings_temp, newViews }
      }

    default:
      const value = {}

      if (!noData && dataTableProps) {
        dataTableProps.forEach(dtp => {
          const dtPropName = _.camelCase(dtp)
          value[dtPropName] = {
            caption: _.startCase(dtPropName),
            key: dtPropName,
            id: dtPropName,
            show: true,
            formItemType: 'text'
          }
        })
      }

      switch (initViType) {

        // *************** RSS FEEDS ***************
        case viTypes.rssFeeds:
          const { settings_global } = _settings_temp ?? {}
          if (settings_global && settings_global.rssFeeds) {
            settings_global.rssFeeds[newValue] = {}
            handleResponse_settingsAdded(_settings_temp)
          }
          break;

        // *************** GLOBAL PAGE ITEMS ***************
        case viTypes.globalPageItems:

          if (!settings_temp_global) { settings_temp_global = {} }
          if (!settings_temp_global.viewItems) { settings_temp_global.viewItems = {} }
          await fn_cls.createViewItem(newValue, true, settings_temp_global.viewItems)
          return { settings_temp: settings_temp_global }
        // return { settings_temp_global }

        // *************** VIEW ITEMS ***************
        // add selected appViewItems to view.page viewItems
        case viTypes.viewItems:
          if (seletedKeys && _settings_temp) {

            let newVi;

            if (!_viewItems) {
              _viewItems = {}
              newVi = true
            }

            seletedKeys.forEach(async nvi => {

              // aps_viewItems are the existing pages/views
              if (aps_viewItems[nvi]) {
                await addViewItemToViewItems(_viewItems, aps_viewItems, nvi)
                if (!_.isEmpty(_settings_temp.page)) {
                  const newSettings = {
                    ..._settings_temp,
                    page: {
                      ..._settings_temp.page, // keep existing values (if any)
                      show: true,
                      layout: { layoutType: 'swipeable' },
                      menu: { captionType: 'fixed', caption: _.startCase(nvi) },
                      viewItems: _viewItems
                    }
                  };
                  console.log('newSettings', newSettings)
                  _settings_temp.page = {
                    show: true,
                    layout: { layoutType: 'swipeable' },
                    menu: { captionType: 'fixed', caption: _.startCase(nvi) },
                    viewItems: _viewItems
                  }
                } else {
                  if (newVi) {
                    _settings_temp.page.viewItems = _viewItems
                  }
                }
              } else {
                // item does not exist  
                await fn_cls.createViewItems(seletedKeys, aps_viewItems)
                _viewItems = aps_viewItems
                await fn_cls.createViews(aps_viewItems, aps_views, true)

                if (aps_viewItems[nvi]) {
                  _viewItems[nvi] = aps_viewItems[nvi]
                  _viewItems[nvi].key = nvi
                  _viewItems[nvi].position = Object.keys(_viewItems).length
                  handleResponse_settingsAdded(_settings_temp)
                }

                await fn_cls.createViewItems(seletedKeys, aps_viewItems)
                _viewItems = aps_viewItems
                await fn_cls.createViews(aps_viewItems, aps_views, true)
                if (aps_viewItems[nvi]) {
                  _viewItems[nvi] = aps_viewItems[nvi]
                  _viewItems[nvi].key = nvi
                  _viewItems[nvi].position = Object.keys(_viewItems).length
                  handleResponse_settingsAdded(_settings_temp)
                }
              }
            })
            handleResponse_settingsAdded(_settings_temp)
          }
          return { settings_temp: _settings_temp }

        // *************** VIEWS ***************
        // case here we are adding a new view/page to the settings in the project
        case viTypes.views:

          let viKeys;
          switch (addModeType_state) {
            case _amts.listAdd:
              viKeys = [formData.name]
              break;

            default:
              // adding new items 
              if (seletedKeys && seletedKeys.length > 0) {
                viKeys = seletedKeys
              } else if (newValue) {
                viKeys = [newValue_cc]
                // viKeys = [newValue]
              }
          }

          if (viKeys) {
            switch (addModeType_state) {
              case _amts.listAdd:
                await createViewItemsAndViews(_settings_temp, viKeys, aps_viewItems, aps_views, formData.pageFields)
                break;
              default:
                await createViewItemsAndViews(_settings_temp, viKeys, aps_viewItems, aps_views)
              // nothing
            }

            return { settings_temp: _settings_temp }
          }

          return { settings_temp: _settings_temp }

        // *************** PROPS ***************
        case viTypes.props:

          // get the current viewItem
          let viewItem_vit = isGlobal ? aps_viewItems[vit] : aps_page.viewItems[vit]
          const { viSection } = swipedItem ?? {}
          const newProps = {}
          const allowNewProps = true

          if (viewItem_vit) {
            if (viewItem_vit.props) {
              // check existance

              // get the new props
              const propsToAdd = {}
              if (seletedKeys && seletedKeys.length > 0) {
                seletedKeys.forEach(si => { propsToAdd[si] = { key: si } })
              } else if (newValue) {
                if (!viewItem_vit.props[newValue]) { propsToAdd[newValue] = { key: newValue } }
              }

              if (allowNewProps) {
                await createViewItemProps(fn_cls, _settings_temp, propsToAdd, isGlobal, _viewItems, vit, viewItem_vit, viSection, aps_page, aps_viewItems, aps_views, handleResponse_settingsAdded)
                console.log('settings_temp - settingsAdd', _settings_temp)
                return { settings_temp: _settings_temp, newProps: propsToAdd, vit }
              } else {
                console.log('propsToAdd', propsToAdd)
              }
              // return { settings_temp_global: settings_temp, newProps: propsToAdd, vit }

            }
          } else {
            if (!settings_temp_global) { settings_temp_global = {} }
            if (!settings_temp_global.viewItems) { settings_temp_global.viewItems = {} }

            if (selectedItems) {
              selectedItems.forEach(si => {
                newProps[si] = { key: si }
              })

            } else if (newValue) {
              if (!viewItem_vit.props[newValue]) {
                newProps[newValue] = { key: newValue }
              }
            }

            await fn_cls.createViewItemProps(newProps, viewItem_vit.props)

            if (!viewItem_vit.propSections[gEnums.sectionHeaderNames.details]) {
              // add the section if it does not exist  
              await fn_cls.createViewItemPropSection(gEnums.sectionHeaderNames.details, null, viewItem_vit.propSections)
              _viewItems = isGlobal ? aps_viewItems : aps_page.viewItems
              ammendTempSettingsState(_settings_temp, isGlobal, null, _viewItems)
              return { settings_temp: settings_temp_global, newProps, vit }
              // return { settings_temp_global, newProps, vit }
            } else {
              _viewItems = isGlobal ? aps_viewItems : aps_page.viewItems
              ammendTempSettingsState(_settings_temp, isGlobal, null, _viewItems)
              return { settings_temp: settings_temp_global, newProps, vit }
              // return { settings_temp_global, newProps, vit }
            }
          }

          return {
            ...state,
            showAddViewItem: false,
            showAddViewItemNoData: false,
          }


        // *************** PROP SECTIONS ***************
        case viTypes.propSections:

          let _viewItems_page = isGlobal ? aps_viewItems : aps_page.viewItems
          let _viewItem_page = _viewItems_page[vit]

          if (_viewItem_page) {
            if (!_viewItem_page.propSections[newValue]) {
              await fn_cls.createViewItemPropSection(newValue, null, _viewItem_page.propSections)
              // _viewItem_page will now include the new propSection
              if (isGlobal) {
                _settings_temp.gvvi.viewItems[vit] = _viewItem_page
              } else {
                _settings_temp.page.viewItems[vit] = _viewItem_page
              }
              return { settings_temp: _settings_temp }
              // return { settings_temp_global: settings_temp }
            }
          } else {
            if (!settings_temp_global) { settings_temp_global = {} }
            if (!settings_temp_global.viewItems) { settings_temp_global.viewItems = {} }
            _viewItem_page = settings_temp_global.viewItems[vit]
            if (!_viewItem_page.propSections[newValue]) {
              await fn_cls.createViewItemPropSection(newValue, null, _viewItem_page.propSections)
              ammendTempSettingsState(_settings_temp, isGlobal, null, _viewItems_page)
              return { settings_temp: _settings_temp }
              // return { settings_temp_global: settings_temp }
            }
          }

          return {
            ...state,
            showAddViewItem: false,
            showAddViewItemNoData: false,
          }

        case viTypes.forms:
          addForm(action.formData, action.fit, paps_state, page_fns)
          return { ...state }

        default:
        // nothing

      }
  }

  return {
    ...state,
    newValue,
  }
}

/**
 * Creates viewItems and views. Updates the settings_temp object
 * @param {array} viKeys 
 * @param {string} addModeType_state 
 * @param {object} settings_temp 
 * @param {object} aps_page 
 * @param {object} aps_viewItems 
 * @param {object} aps_views  
 */
const createViewItemsAndViews = async (settings_temp, viKeys, aps_viewItems, aps_views, newProps) => {
  // create new viewItems based on the viKeys 
  await fn_cls.createViewItems(viKeys, aps_viewItems, newProps)
  await fn_cls.createViews(aps_viewItems, aps_views, true, newProps)
  ammendTempSettingsState(settings_temp, true, null, aps_viewItems, aps_views)
}

/** create props for the viewItem */
const createViewItemProps = async (fn_cls, settings_temp, propsToAdd, isGlobal, _viewItems, vit, viewItem_vit, viSection, aps_page, aps_viewItems, aps_views, handleResponse_settingsAdded) => {

  // newProps, propSection, existingProps
  await fn_cls.createViewItemProps(propsToAdd, viewItem_vit.props, viSection ? viSection : gEnums.sectionHeaderNames.details,)

  // add a new propSection if needed
  if (!viewItem_vit.propSections[gEnums.sectionHeaderNames.details]) {
    // FUNCTIONS
    await fn_cls.createViewItemPropSection(gEnums.sectionHeaderNames.details, null, viewItem_vit.propSections)
    await addViewItemPropViews(_viewItems, aps_views, viewItem_vit, propsToAdd, vit)
    _viewItems = isGlobal ? aps_viewItems : aps_page.viewItems
    settings_temp.gvvi.viewItems = _viewItems
    ammendTempSettingsState(settings_temp, isGlobal, null, _viewItems)
  } else {
    await addViewItemPropViews(_viewItems, aps_views, viewItem_vit, propsToAdd, vit)
    _viewItems = isGlobal ? aps_viewItems : aps_page.viewItems
    ammendTempSettingsState(settings_temp, isGlobal, null, _viewItems)
  }
}

/** adds a viewItem to viewItems */
const addViewItemToViewItems = async (_viewItems, aps_viewItems, viKey) => {
  _viewItems[viKey] = aps_viewItems[viKey]
  _viewItems[viKey].key = viKey
  _viewItems[viKey].position = Object.keys(_viewItems).length
  delete _viewItems[viKey].dataConnection
}

const ammendItem = (item, name, copyFrom) => {
  item.menu.caption = _.startCase(name)
  item.viewItems[name] = item.viewItems[copyFrom]
  item.viewItems[name].key = name
  item.viewItems[name].display.caption = _.startCase(name)
  if (!item.viewItems[name].dataSource) { item.viewItems[name].dataSource = {} }
  item.viewItems[name].dataSource.altDataCollectionName = copyFrom
}

const addViewAndViews = (action, viewItems, views) => {

  const { name, copyFrom } = action
  const _name = _.camelCase(name)

  const _viewItem = _.cloneDeep(viewItems[copyFrom]);
  const _view = _.cloneDeep(views[copyFrom]);
  const _viewList = _.cloneDeep(views[copyFrom + '_list']);

  _viewItem.key = _name
  _viewItem.dataConnection.altCollectionName = copyFrom
  _viewItem.display.caption = _.startCase(name)

  ammendItem(_view, _name, copyFrom)
  ammendItem(_viewList, _name, copyFrom)

  viewItems[name] = _viewItem
  views[name] = _view
  views[name + '_list'] = _viewList
}